import { render, staticRenderFns } from "./GeneralSummary.vue?vue&type=template&id=6533c927&"
import script from "./GeneralSummary.vue?vue&type=script&lang=js&"
export * from "./GeneralSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6533c927')) {
      api.createRecord('6533c927', component.options)
    } else {
      api.reload('6533c927', component.options)
    }
    module.hot.accept("./GeneralSummary.vue?vue&type=template&id=6533c927&", function () {
      api.rerender('6533c927', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/operations/components/transactionality/GeneralSummary.vue"
export default component.exports